(function () {
  function slugify(text, index) {
    var base = (text || '')
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
    return (base || 'section') + '-' + index;
  }

  function getCleanHeadingText(heading) {
    if (!heading) return '';
    // Replace non-breaking spaces (\u00a0) and other whitespace
    var text = (heading.textContent || '').replace(/\u00a0/g, ' ').trim();
    return text;
  }

  function isValidHeading(heading) {
    if (!heading) return false;

    // Exclude headings inside non-article content, templates, scripts, hidden elements, or tags/cta
    if (heading.closest('template, script, style, [aria-hidden="true"], .ma-cta, .ma-tags-block, .article-template__comments, [data-no-toc]')) {
      return false;
    }

    // Check if heading has visible text
    var text = getCleanHeadingText(heading);
    if (!text || text.length === 0) {
      return false;
    }

    return true;
  }

  function decodeEscapedHtml(contentEl) {
    if (!contentEl) return;
    var html = contentEl.innerHTML;
    var tagRegex = /&lt;(\/?[a-zA-Z][a-zA-Z0-9]*(?:\s+[^&>]*)?\/?)&gt;/gi;
    if (!tagRegex.test(html)) {
      return;
    }
    contentEl.innerHTML = html.replace(tagRegex, function (match, inner) {
      var cleanInner = inner
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;/g, '&');
      return '<' + cleanInner + '>';
    });
  }

  function insertInlineTakeaways(root) {
    if (!root) root = document;
    var contentEls = root.querySelectorAll('[data-ma-article-content]');
    var desktopCard = root.querySelector('.ma-sidebar .ma-takeaways-card');
    if (!desktopCard || !contentEls.length) return;

    contentEls.forEach(function (contentEl) {
      if (contentEl.querySelector('.ma-takeaways-card--inline')) return;

      var inlineCard = desktopCard.cloneNode(true);
      inlineCard.classList.add('ma-takeaways-card--inline');

      // Find the first paragraph (direct or top-level wrapper)
      var firstP = contentEl.querySelector('p');
      if (firstP) {
        var targetEl = firstP;
        while (targetEl.parentElement && targetEl.parentElement !== contentEl) {
          targetEl = targetEl.parentElement;
        }
        targetEl.insertAdjacentElement('afterend', inlineCard);
      } else if (contentEl.firstElementChild) {
        contentEl.firstElementChild.insertAdjacentElement('afterend', inlineCard);
      } else {
        contentEl.appendChild(inlineCard);
      }
    });
  }

  function buildSidebar(root) {
    if (!root) root = document;

    var contentEls = root.querySelectorAll('[data-ma-article-content]');
    if (contentEls.length) {
      contentEls.forEach(function (contentEl) {
        decodeEscapedHtml(contentEl);
      });
    }

    insertInlineTakeaways(root);

    var tocLists = root.querySelectorAll('[data-ma-toc-list]');
    var takeawaysLists = root.querySelectorAll('[data-ma-takeaways-list]');

    if (!tocLists.length && !takeawaysLists.length) return;
    if (!contentEls.length) return;

    // Collect all valid H2 headings from article content
    var validHeadings = [];
    contentEls.forEach(function (contentEl) {
      var headings = contentEl.querySelectorAll('h2');
      headings.forEach(function (heading) {
        if (isValidHeading(heading)) {
          validHeadings.push(heading);
        }
      });
    });

    if (!validHeadings.length) {
      // No valid headings: clear and hide TOC & Takeaways cards
      tocLists.forEach(function (list) {
        list.innerHTML = '';
        var card = list.closest('.ma-toc-card');
        if (card) card.style.display = 'none';
      });
      takeawaysLists.forEach(function (list) {
        list.innerHTML = '';
        var card = list.closest('.ma-takeaways-card');
        if (card) card.style.display = 'none';
      });
      return;
    }

    // Ensure cards are visible
    tocLists.forEach(function (list) {
      var card = list.closest('.ma-toc-card');
      if (card) card.style.display = '';
    });
    takeawaysLists.forEach(function (list) {
      var card = list.closest('.ma-takeaways-card');
      if (card) card.style.display = '';
    });

    // Build TOC fragment
    var tocFragment = document.createDocumentFragment();
    // Build Takeaways fragment
    var takeawaysFragment = document.createDocumentFragment();

    validHeadings.forEach(function (heading, index) {
      if (!heading.id) {
        heading.id = slugify(getCleanHeadingText(heading), index);
      }

      var rawText = getCleanHeadingText(heading);
      // Strip any existing manual numbering (e.g. "1. ", "1 - ", "1)") so CSS counter renders cleanly
      var cleanText = rawText.replace(/^\s*\d+[\.\:\)\-]\s*/, '').trim() || rawText;

      // TOC item: linked
      var tocLi = document.createElement('li');
      var tocLink = document.createElement('a');
      tocLink.href = '#' + heading.id;
      tocLink.textContent = cleanText;
      tocLi.appendChild(tocLink);
      tocFragment.appendChild(tocLi);

      // Takeaway item: numbered with pink circle
      var takeLi = document.createElement('li');
      var numSpan = document.createElement('span');
      numSpan.className = 'ma-takeaways-list__num';
      numSpan.textContent = String(index + 1);
      var textSpan = document.createElement('span');
      textSpan.className = 'ma-takeaways-list__text';
      textSpan.textContent = cleanText;
      takeLi.appendChild(numSpan);
      takeLi.appendChild(textSpan);
      takeawaysFragment.appendChild(takeLi);
    });

    // Populate TOC lists
    tocLists.forEach(function (list) {
      list.innerHTML = '';
      list.appendChild(tocFragment.cloneNode(true));
    });

    // Populate Takeaways lists
    takeawaysLists.forEach(function (list) {
      list.innerHTML = '';
      list.appendChild(takeawaysFragment.cloneNode(true));
    });
  }

  // Smooth scroll handler for TOC links (delegated on document)
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-ma-toc-list] a');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;
    var targetId = href.slice(1);
    var target = document.getElementById(targetId);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (history.pushState) {
      history.pushState(null, '', '#' + targetId);
    }
  });

  function init() {
    buildSidebar(document);
  }

  /* Run immediately if DOM is already ready, otherwise wait */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run when Shopify re-renders a section in the theme editor */
  document.addEventListener('shopify:section:load', function (event) {
    buildSidebar(event.target);
  });
})();
